import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import DateTimeUtils from "../shared/utils/DateTimeUtils";
import { getUserPageRefresh } from '../auth/sagas';

const controllerUrl = '/entityInterfaces/';

const searchEntityInterfacesCall = (id, searchFields) => new Promise((resolve, reject) => {
    axios.get('/entities/' + id + controllerUrl + 'search', {
        params: {
            ...searchFields
        }
    }).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const getEntityInterfaceCall = (entityId, entityInterfaceId) => new Promise((resolve, reject) => {
    axios.get('/entities/' + entityId + controllerUrl + entityInterfaceId).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const deleteEntityInterfaceCall = (entityId, entityInterfaceId) => new Promise((resolve, reject) => {
    axios.delete('/entities/' + entityId + controllerUrl + entityInterfaceId).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const editEntityInterfaceCall = (entityId, entityInterfaceId, entityInterfaceData) => new Promise((resolve, reject) => {
    axios.put('/entities/' + entityId + controllerUrl + entityInterfaceId, entityInterfaceData).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const createEntityInterfaceCall = (entityId, entityInterfaceData) => new Promise((resolve, reject) => {
    axios.post('/entities/' + entityId + controllerUrl, entityInterfaceData).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

function* searchEntityInterfacesRequest({ entityId, searchFields }) { //Warning: String values are normalized for presentation in tables
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const searchResults = yield call(searchEntityInterfacesCall, entityId, searchFields);

        const searchResultsWithReading = {
            ...searchResults,
            content: searchResults.content.map(
                entityInterfaceInstance => ({
                    ...entityInterfaceInstance,
                    lastCommunicationTimestamp: entityInterfaceInstance.terminalInterface.lastCommunicationTimestamp ? DateTimeUtils.getDateTimeFromUnix(entityInterfaceInstance.terminalInterface.lastCommunicationTimestamp) : null,
                    lastReading: entityInterfaceInstance.terminalInterface.lastReading
                })
            ),
            sort: searchResults.sort.map(sortCriteria => ({
                    ...sortCriteria,
                    property: fixSortProperty(sortCriteria)
                })
            )
        };

        yield put({
            type: actionTypes.ENTITY_INTERFACE_SEARCH_SUCCESS,
            payload: searchResultsWithReading
        });
    } catch (e) {
        yield put({
            type: actionTypes.ENTITY_INTERFACE_SEARCH_FAILED,
            payload: e
        });
    }
}

function* getEntityInterfaceRequest({ entityId, entityInterfaceId }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const entityInterface = yield call(getEntityInterfaceCall, entityId, entityInterfaceId);

        entityInterface.entity = entityInterface.entityId;
        yield put({
            type: actionTypes.GET_ENTITY_INTERFACE_SUCCESS,
            payload: entityInterface
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_ENTITY_INTERFACE_FAILED,
        });
    }
}

function* createEntityInterfaceRequest({ interfaceId, entityInterfaceData }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        entityInterfaceData.terminalInterfaceId = interfaceId;
        let entityId = entityInterfaceData.entity;

        yield call(createEntityInterfaceCall, entityId, entityInterfaceData);

        yield put({
            type: actionTypes.CREATE_ENTITY_INTERFACE_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.CREATE_ENTITY_INTERFACE_FAILED
        })
    }
}

function* editEntityInterfaceRequest({ entityId, entityInterfaceId, entityInterfaceData }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        entityInterfaceData.terminalInterfaceId = entityInterfaceData.terminalInterface.id;

        yield call(editEntityInterfaceCall, entityId, entityInterfaceId, entityInterfaceData);

        yield put({
            type: actionTypes.EDIT_ENTITY_INTERFACE_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.EDIT_ENTITY_INTERFACE_FAILED
        })
    }
}

function* deleteEntityInterfaceRequest({ entityId, entityInterfaceId }) {
    try {
        yield call(deleteEntityInterfaceCall, entityId, entityInterfaceId);

        yield put({
            type: actionTypes.DELETE_ENTITY_INTERFACE_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.DELETE_ENTITY_INTERFACE_FAILED
        })
    }
}

function fixSortProperty({property}) {
    switch (property) {
        case "terminalInterface.lastCommunicationTimestamp":
            return "lastCommunicationTimestamp";
        default:
            return property
    }
}

const entityInterfaceSagas = [
    takeEvery(actionTypes.ENTITY_INTERFACE_SEARCH_REQUEST, searchEntityInterfacesRequest),
    takeEvery(actionTypes.GET_ENTITY_INTERFACE_REQUEST, getEntityInterfaceRequest),
    takeEvery(actionTypes.CREATE_ENTITY_INTERFACE_REQUEST, createEntityInterfaceRequest),
    takeEvery(actionTypes.EDIT_ENTITY_INTERFACE_REQUEST, editEntityInterfaceRequest),
    takeEvery(actionTypes.DELETE_ENTITY_INTERFACE_REQUEST, deleteEntityInterfaceRequest),
];

export {
    entityInterfaceSagas,
};